export default __webpack_public_path__ + "static/media/d3va.a91258be.png";